import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getJobEmployeeReplacements } from "./Axios";

const EmployeeReplacementsSelect = props => {
  const [employeeReplacements, setEmployeeReplacements] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "employeeReplacement");
  };

  useEffect(() => {
    getJobEmployeeReplacements((response) => {
      if (response && response.data) {
        const newEmployeeReplacements = response.data.map((employeeReplacements) => ({
          value: employeeReplacements.id,
          label: employeeReplacements.name,
          document_number: employeeReplacements.document_number,
          email: employeeReplacements.email,
          is_active: employeeReplacements.is_active
        }));
        setEmployeeReplacements(newEmployeeReplacements);
      }
    });
  }, []);

  return (
    <Select
      inputId="employee-replacement-search"
      onChange={handleChange}
      options={employeeReplacements}
      placeholder="Buscar y seleccionar a quién remplaza"
      value={
        employeeReplacements.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label} ${e.document_number}. (${e.email}) (${e.is_active ? "activo" : "inactivo"})`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label, document_number } = option.data;
        return (
          label.toLowerCase().includes(searchTerm) ||
          document_number.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default EmployeeReplacementsSelect;

